import request from '@/utils/request'

import { SyncServerSetting } from '@/types/sync'

export function GetSetting(): Promise<SyncServerSetting> {
  return request.get('/sync/setting')
}

export function PatchSetting(s: SyncServerSetting): Promise<SyncServerSetting> {
  return request.patch('/sync/setting', s)
}
